var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonAddEnabled = function SvgButtonAddEnabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 -6.10352e-05C8.96 -6.10352e-05 0 8.95994 0 19.9999C0 31.0399 8.96 39.9999 20 39.9999C31.04 39.9999 40 31.0399 40 19.9999C40 8.95994 31.04 -6.10352e-05 20 -6.10352e-05ZM28 21.9999H22V27.9999C22 29.0999 21.1 29.9999 20 29.9999C18.9 29.9999 18 29.0999 18 27.9999V21.9999H12C10.9 21.9999 10 21.0999 10 19.9999C10 18.8999 10.9 17.9999 12 17.9999H18V11.9999C18 10.8999 18.9 9.99994 20 9.99994C21.1 9.99994 22 10.8999 22 11.9999V17.9999H28C29.1 17.9999 30 18.8999 30 19.9999C30 21.0999 29.1 21.9999 28 21.9999Z",
    fill: "#0A446D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonAddEnabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ButtonAddEnabled.53a0b710.svg";
export { ForwardRef as ReactComponent };